import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "signInPage" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "waField" };
const _hoisted_4 = { class: "waFieldValue" };
const _hoisted_5 = { class: "waActions" };
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useWhatsApp } from '@/composables/useWhatsApp';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
const NEXT_PATH = '/signin/notifications';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SignInWhatsAppPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { enableWhatsApp } = useWhatsApp({ whatsAppPromoCard: null, whatsAppEnableDrawer: null, whatsAppNumber: '' });
        function onLoad() {
            getCustomer(() => {
                // Nothing to ask: already on WhatsApp, or no number to message
                if (state.customer?.person?.whatsAppEnabled || !state.customer?.person?.mobilePhone) {
                    router.replace({ path: NEXT_PATH });
                }
            });
        }
        function enable() {
            enableWhatsApp();
            router.push({ path: NEXT_PATH });
        }
        function skip() {
            router.push({ path: NEXT_PATH });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "WhatsApp Assistant",
                    border: 0
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                        class: "waIllustration",
                        src: require('@/assets/signin/whatsapp_illustration.png'),
                        alt: ""
                    }, null, 8, _hoisted_2),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "waCopy" }, [
                        _createElementVNode("h1", { class: "waTitle" }, "Get support on WhatsApp"),
                        _createElementVNode("p", { class: "waSubtitle" }, "Wherever you are, whenever you need help, drop the digital financial assistant a message on WhatsApp.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _cache[0] || (_cache[0] = _createElementVNode("label", null, "Mobile number*", -1)),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(state).customer?.person?.mobilePhone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "waConsent" }, "By continuing, you agree to receive WhatsApp messages from Money Guided at this number. WhatsApp processes messages under its own privacy policy. You can opt out at any time.", -1)),
                        _createVNode(MGButton, {
                            text: "Continue with WhatsApp",
                            stacked: true,
                            arrow: true,
                            fullWidth: true,
                            onClick: enable
                        }),
                        _createVNode(MGButton, {
                            text: "Not now",
                            noCaps: true,
                            stacked: true,
                            fullWidth: false,
                            onClick: skip,
                            outline: false,
                            transparent: true,
                            arrow: true,
                            inlineArrow: true
                        })
                    ])
                ])
            ], 64));
        };
    }
});
